import type { FC } from 'react';
import React from 'react';
import { ModalMobile } from '@alfalab/core-components-modal/mobile';

import type { TWrapperMobileProps } from '../../models';

export const MobileWrapper: FC<TWrapperMobileProps> = ({
    children,
    isOpened,
    onClose,
    subtitle,
    title,
    titleSize,
}) => {
    return (
        <ModalMobile onClose={onClose} open={isOpened}>
            <ModalMobile.Header hasCloser {...{ title, titleSize, subtitle }} />
            <ModalMobile.Content>{children}</ModalMobile.Content>
        </ModalMobile>
    );
};
